export default {
  "Loop as a GIF": "像GIF一樣迴圈",
  "without sound": "沒有聲音",
  "Final output duration": "最終導出時長",
};
